import { render } from "./pldfExcl.vue?vue&type=template&id=c5b2f698"
import script from "./pldfExcl.vue?vue&type=script&lang=js"
export * from "./pldfExcl.vue?vue&type=script&lang=js"

import "./pldfExcl.vue?vue&type=style&index=0&id=c5b2f698&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__